exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tMRayaVF4l2Y1JKzwxqDV{color:red;margin-top:-1.5rem;font-size:0.85714rem;text-align:end;margin-bottom:1rem}\n", ""]);

// exports
exports.locals = {
	"errorMessage": "tMRayaVF4l2Y1JKzwxqDV"
};